import { GeofenceRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * updateGeofenceByCustomerAndDepartment - Function that updates on database an existing geofence by id   
 * /geofences/{id}  
 * method PUT 
 * @async-function
 */
const updateGeofenceByCustomerAndDepartment = async (token: string, id: number, model: GeofenceRequestType) => {
    const response = await api.put(
        `/geofences/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updateGeofenceByCustomerAndDepartment;